import * as React from 'react';
import { useCheckboxGroupOptions } from '../../internal';
import { CheckboxChipButton } from '../CheckboxChipButton';
import { ChipsGroup } from '../../../internal/components/Chip';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated использовать компонент Chips с пропсом selectType=multiple
 */
export var CheckboxChipsGroup = /*#__PURE__*/React.memo(function CheckboxChipsGroup(props) {
  var value = props.value,
    disabled = props.disabled,
    invalid = props.invalid,
    name = props.name,
    role = props.role,
    inline = props.inline,
    size = props.size,
    title = props.title,
    titleWeight = props.titleWeight,
    fullWidth = props.fullWidth,
    iconPosition = props.iconPosition,
    counterMaxLength = props.counterMaxLength,
    scrollable = props.scrollable,
    defaultValue = props.defaultValue;
  var options = useCheckboxGroupOptions(props);
  return /*#__PURE__*/_jsx(ChipsGroup, {
    title: title,
    size: size,
    titleWeight: titleWeight,
    role: role,
    inline: inline,
    fullWidth: fullWidth,
    scrollable: scrollable,
    children: options.map(function (_ref) {
      var optionValue = _ref.value,
        label = _ref.label,
        onChange = _ref.onChange,
        icon = _ref.icon,
        counter = _ref.counter;
      var key = String(optionValue);
      return /*#__PURE__*/_jsx(CheckboxChipButton, {
        name: name,
        value: key,
        checked: inList(optionValue, value),
        defaultChecked: defaultValue ? inList(optionValue, defaultValue) : undefined,
        disabled: disabled,
        invalid: invalid,
        label: label,
        onChange: onChange,
        role: role === 'listbox' ? 'option' : undefined,
        size: size,
        counterMaxLength: counterMaxLength,
        iconPosition: iconPosition,
        icon: icon,
        counter: counter,
        scrollInView: scrollable
      }, key);
    })
  });
});
function inList(item, list) {
  return !!(list !== null && list !== void 0 && list.some(function (value) {
    return value === item;
  }));
}